import Axios from 'axios'
import store from '../store'
import utils from '@/utils/utils.js'

const report = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getToken(reportGroupId, reportKey) {
    return Axios.get('api/external/clients/' + this.getClientId() + '/reports/' + reportKey + '/reportGroupId/' + reportGroupId)
  },
  getDashboardMonitoringToken() {
    return Axios.get(`/api/internal/clients/${this.getClientId()}/reports/dashboards/monitoring`)
  },
  getDashboardRoomToken() {
    return Axios.get(`/api/internal/clients/${this.getClientId()}/reports/dashboards/rooms`)
  },
  getFilterRoomEventReport () {
    return Axios.get(`/api/internal/clients/${this.getClientId()}/reports/event-rooms/filters`)
  },
  getRoomEventReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`/api/internal/clients/${this.getClientId()}/reports/event-rooms`, config)
  },
  getRoomEventReportFile(filters) {
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`/api/internal/clients/${this.getClientId()}/reports/event-rooms/file`, config)
  }
}

export default report
